const WARNING_ACTION_TYPES = {
  tip: "tip",
  payment: "payment",
};

export default WARNING_ACTION_TYPES;
